import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { NoteAddIcon } from 'components/SVG';
import { useBoardNodeTypes } from 'hooks/EntityTypes/useBoardNodeTypes';
import { usePopover } from 'hooks/common';
import React from 'react';
import { SparkImageLoader } from 'sharedComponents/UI';

type AddBoardNodeOptionsProps = {
  onAdd: (nodeTypeID: number) => void;
  isLoading?: boolean;
};

function AddBoardNodeOptions({
  onAdd,
  isLoading = false,
}: AddBoardNodeOptionsProps) {
  const { dropdownOptions } = useBoardNodeTypes();
  const { anchorEl, openPopover, closePopover } = usePopover();
  const handleClick = (nodeTypeID: number) => {
    closePopover();
    onAdd(nodeTypeID);
  };
  return (
    <>
      <IconButton
        aria-label='AddCircleRoundedIcon'
        onClick={openPopover}
        size='small'
        disabled={isLoading}
      >
        <NoteAddIcon
          width='20px'
          height='20px'
          color={isLoading ? 'lightGray' : 'black'}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ top: '6px' }}
      >
        {dropdownOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleClick(+option.value)}
          >
            <Box display='flex' alignItems='center' gap={1}>
              <SparkImageLoader src={option.iconUrl} alt={option.iconUrl} />
              <Typography marginTop={0.5}>{option.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default AddBoardNodeOptions;
